import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-addFiles",
  "use": "icon-addFiles-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-addFiles\"><defs><style type=\"text/css\"></style></defs><path d=\"M831.6 575.6h-63.9v127.9H639.9v63.9h127.8v127.9h63.9V767.4h127.9v-63.9H831.6z\" p-id=\"981\" fill=\"#0099FF\" /><path d=\"M831.6 192.1H703.8c0-70.3-57.5-127.9-127.9-127.9H192.4c-70.3 0-127.9 57.5-127.9 127.9V767.5c0 70.3 57.5 127.9 127.9 127.9H576v-63.9H192.4c-35.2 0-63.9-28.7-63.9-63.9V192.1c0-35.2 28.7-63.9 63.9-63.9H576c35.2 0 63.9 28.7 63.9 63.9V256h191.8c35.2 0 63.9 28.7 63.9 63.9v191.8h63.9V319.9c0-70.3-57.5-127.8-127.9-127.8z\" p-id=\"982\" fill=\"#0099FF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/addFiles.svg
// module id = vSOy
// module chunks = 81